module.exports = __webpack_public_path__ + "img/missing-page-illustration.66e108b8.svg";